;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import { gql } from "@apollo/client"

export const GET_ORGANIZATION = gql`
  query getOrganization($pOrgId: UUID!) {
    getOrganization(pOrgId: $pOrgId) {
      nodes {
        contactEmail
        contactPhone
        createdAt
        ein
        id
        intakeEmail
        isPersonal
        name
        photoUrl
        privateMetadata
        publicProfile
        publishedAt
        stripeConnectId
        website
      }
    }
  }
`
